import { render } from "./LeiturasDispositivo.vue?vue&type=template&id=65519162&scoped=true"
import script from "./LeiturasDispositivo.vue?vue&type=script&lang=js"
export * from "./LeiturasDispositivo.vue?vue&type=script&lang=js"

import "./LeiturasDispositivo.vue?vue&type=style&index=0&id=65519162&scoped=true&lang=css"
import "./LeiturasDispositivo.vue?vue&type=style&index=1&id=65519162&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65519162"]])

export default __exports__